import { selectUserOrgByApp } from '@rsos/sinatra';
import { patchIssue } from '../../services/capstone';
import {
  UPDATE_ISSUE_START,
  UPDATE_ISSUE_SUCCESS,
  UPDATE_ISSUE_FAILED,
} from '../actionTypes';

export const updateIssueStart = () => ({
  type: UPDATE_ISSUE_START,
});

export const updateIssueSuccess = issue => ({
  type: UPDATE_ISSUE_SUCCESS,
  issue,
});

export const updateIssueFailed = error => ({
  type: UPDATE_ISSUE_FAILED,
  error,
});

/**
 * Updates the status for the given issue.
 * @param {Object} issue - The issue object
 * @param {string} issue.issue_key - The key for the issue
 * @param {string} status - The updated issue status
 */
const updateIssue = (issue, status) => (dispatch, getState) => {
  const { sinatra } = getState();
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);

  dispatch(updateIssueStart());
  return patchIssue(issue, org.name, status)
    .then(() => {
      // NOTE patching the issue returns a 204 on success,
      // passing along the original issue here.
      const updatedIssue = {
        ...issue,
        status,
      };
      return dispatch(updateIssueSuccess(updatedIssue));
    })
    .catch(error => {
      throw dispatch(updateIssueFailed(error));
    });
};

export default updateIssue;
